module.exports = __webpack_public_path__ + "assets/img/login_total.91b5de7f.png";